import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApproveInputModel } from 'src/app/ViewModel/PeerReviewModel';
import { CommonService } from '../Common.service';
import { RestApiService } from '../rest-api.service';
import { PeerRequestInput, DocViewInput } from 'src/app/ViewModel/PeerReviewModel';


@Injectable({
  providedIn: 'root'
})
export class PeerReviewService {

  private getReviewList = 'PeerReview/GetPeerReviewList';
  private getApprovePeerReviewList = 'PeerReview/GetApprovePeerReviewList';
  private postApprovePeerReviewList = 'PeerReview/PostApprovePeerReviewList';

  private getReason = "DEDED/GetDEDForPeerResponse";
  private getImpactStatus = "DEDED/GetDEDImpactStatus";
  private getCommentDropdowns = "DEDED/GetDEDForPeerComments";
  private getStatus = "PeerReview/GetPeerReviewDetails";
  private postStatus = "PeerReview/UpdatePeerReviewStatus";
  private editStatus = "PeerReview/GetPeerReviewEditInvite";
  private getComments = "PeerReview/GetPeerReviewComments";
  private postComments = "PeerReview/PostPeerReviewComments";
  private getResponse = "PeerReview/GetPeerReviewResponseDetails";
  private postResponse = "PeerReview/PostPeerReviewResponse";
  private getImpacts = "PeerReview/GetPeerReviewImpactsDetails";
  private getImpactsTypes = "PeerReview/GetPeerReviewImpactsTypes";
  private postImpacts = "PeerReview/PostPeerReviewImpacts";
  private postCreateReq = "PeerReview/PostPeerReviewCreate";
  private getpeerDocview = "PeerReview/GetPeerDocView";
  private getpeerDocflow = "PeerReview/GetPeerDocFlow"
  private getpresenter = "PeerReview/GetPresenterView";
  private getpanel = "PeerReview/GetPanel";
  private getcri = "PeerReview/GetCRI";


  private GetPRInvitationMasterData = "PeerReview/GetPRInvitationMasterData";
  private GetEcdMem = "PeerReview/GetECDMembers";
  private GetPRInvitationRoleMasterData = "PeerReview/GetPRInvitationRoleMasterData";
  private GetPeerStatus = "PeerReview/GetPeerStatus";
  private GetPRInvitationDisciplineMasterData = "PeerReview/GetPRInvitationDisciplineMasterData";
  PostPRInvitationMembers = "PeerReview/PostPRInvitationMembers";
  GetPRInvitationMembers = "PeerReview/GetPRInvitationMembers";
  private getPRdashboard = "PeerReview/GetPeerReviewDashboard";
  private updateReviewCheckList = 'PeerReview/UpdateCheckListId';

  constructor(private restAPIService: RestApiService, private commonService: CommonService) { }

  public GetApproveReviewDetails(project_Id: number): Observable<any> {
    let _obj = {
      project_Id: project_Id
    }
    return this.restAPIService.new_POST(this.getApprovePeerReviewList, _obj)
  }

  public PostApproveReviewDetails(input: IApproveInputModel) {
    return this.restAPIService.new_POST(this.postApprovePeerReviewList, input);
  }

  public GetReviewList(input: any): Observable<any> {

    return this.restAPIService.new_POST(this.getReviewList, input)
  }

  getReasonData(): Observable<any> {
    let obj = {
      "intDEID": 507,
      "intUID": this.commonService.getLoggedInUserId()
    }
    return this.restAPIService.new_POST(this.getReason, obj);
  }

  getimpactStatus(): Observable<any> {
    let obj = {
      "intProjectID": this.commonService.getProjectId(),
      "intGroupID": this.commonService.getLoggedInUserGroupId(),
      "intUID": this.commonService.getLoggedInUserId()
    }
    return this.restAPIService.new_POST(this.getImpactStatus, obj);
  }

  getCommentData(obj1: any): Observable<any> {
    let obj:any;
    if(this.commonService.redirectUserToPRAddComments)
    {
       obj = {
        "intProjectID": this.commonService.redirectUserToPRAddComments_Projectid,
        "intGroupID": this.commonService.redirectUserToPRAddComments_GrpID,
        "strDocNo": obj1,
        "intUID": this.commonService.getLoggedInUserId()
      }
    }
    else
    {
       obj = {
        "intProjectID": this.commonService.getProjectId(),
        "intGroupID": this.commonService.getLoggedInUserGroupId(),
        "strDocNo": obj1,
        "intUID": this.commonService.getLoggedInUserId()
      }
    }
    return this.restAPIService.new_POST(this.getCommentDropdowns, obj);
  }

  getReviewStatus(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.getStatus, obj);
  }
  

  postReviewStatus(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.postStatus, obj);
  }

  GetPeerReviewEditInvite(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.editStatus, obj);
  }

  getReviewComments(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.getComments, obj);
  }

  postReviewComments(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.postComments, obj);
  }

  getReviewResponse(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.getResponse, obj);
  }

  postReviewResponse(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.postResponse, obj);
  }

  getPRInvitationMasterData(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.GetPRInvitationMasterData, obj);
  }

  getECDMembers(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.GetEcdMem, obj);
  }

  getPeerStatus(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.GetPeerStatus, obj);
  }

  getPRInvitationRoleMasterData(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.GetPRInvitationRoleMasterData, obj);
  }

  getPRInvitationDisciplineMasterData(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.GetPRInvitationDisciplineMasterData, obj);
  }

  postPRInvitationMembers(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.PostPRInvitationMembers, obj);
  }

  getReviewImpacts(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.getImpacts, obj);
  }
  getPeerImpactsTypes(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.getImpactsTypes, obj);
  }
  postReviewImpacts(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.postImpacts, obj);
  }
  postpeerRequest(create: PeerRequestInput) {
    return this.restAPIService.new_POST(this.postCreateReq, create);
  }
  getPRInvitationMembers(obj: any): Observable<any> {
    return this.restAPIService.new_POST(this.GetPRInvitationMembers, obj);
  }
  getPeerDocView(datainput: DocViewInput)
  {
    return this.restAPIService.new_POST(this.getpeerDocview,datainput);
  }
  getPeerDocFlow(datainput: DocViewInput)
  {
    return this.restAPIService.new_POST(this.getpeerDocflow,datainput);
  }
  getPeerPresenter(datainput: DocViewInput)
  {
    return this.restAPIService.new_POST(this.getpresenter,datainput);
  }
  getPeerPanelMembers(datainput: DocViewInput)
  {
    return this.restAPIService.new_POST(this.getpanel,datainput);
  }
  getPeerCRI(datainput: DocViewInput)
  {
    return this.restAPIService.new_POST(this.getcri,datainput);
  }

  getPRDashboard(obj: any)
  {
    return this.restAPIService.new_POST(this.getPRdashboard,obj);
  }

  UpdateReviewChecklist(obj:any)
  {
    return this.restAPIService.new_POST(this.updateReviewCheckList,obj);
  }
}
